<template>
  <div class="mobile-terminal">
    <AppBar />
    <div class="page-content">
      <div class="page-canvas">
        <div class="page-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
              <!-- 利用在线招聘流程，帮助企业实现智能、便捷的招聘模式，
              建立企业自己的人才储备机制 -->
            </div>
          </div>
        </div>
      </div>
      <div ref="nav" class="page-nav">
        <div
          ref="navTabs"
          class="page-tabs"
          :style="{ width: navWidth + '%', height: navHeight + 'px' }"
        >
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="[
              'page-nav-item',
              topNaviId === item.id ? 'top-nav-item' : ''
            ]"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div>
        <div ref="pain-points" class="pain-points">
          <div class="title">企业审批痛点</div>
          <div class="pain-points-list">
            <div
              v-for="(item, index) in painPointsList"
              :key="index"
              class="pain-points-list-item"
            >
              <div class="list-item-icon">
                <img :src="item.icon" alt="" class="icon" />
              </div>
              <div class="list-item-text">
                <div class="list-item-title">{{ item.title }}</div>
                <div class="list-item-describe">{{ item.describe }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="sense-of-worth" class="sense-of-worth">
          <div class="title">产品价值体现</div>
          <div class="sense-of-worth-list">
            <div
              v-for="(item, index) in senseOfWorthList"
              :key="index"
              :style="{ background: `url('${item.backImg}') no-repeat` }"
              class="sense-worth-item"
            >
              <div class="item-content">
                <div class="item-title">{{ item.title }}</div>
                <div class="item-text">{{ item.text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="solution" class="solution">
          <div class="title">移动端解决方案</div>
          <div v-if="SolutionList.length != 0" class="solution-content">
            <div class="solution-content-tabinfo-wrap">
              <div
                v-for="(item, index) in SolutionList"
                :key="index"
                class="tabinfo-item"
                :class="{ 'chack-tabInfo': index === solutionIndex }"
                @click="onClick(index)"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="solution-content___tabText">
              <transition name="tabContentWrap">
                <div :key="solutionIndex" class="solution-content__tabWrap">
                  <div class="content__tabWrap-top">
                    <div class="solution-content__tabtit">
                      {{ SolutionList[solutionIndex].title }}
                    </div>
                    <div class="solution-content__tabDes">
                      {{ SolutionList[solutionIndex].text }}
                    </div>
                  </div>
                  <img
                    :src="SolutionList[solutionIndex].img"
                    alt=""
                    class="solution-content__tabImage"
                  />
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column'
import { getContentList, getContentDetail } from '@/api/content'

export default {
  name: 'MobileTerminal',
  data() {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/mobile/canvas.gif')
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      topNaviId: null,
      navList: [
        {
          title: '企业痛点',
          id: 'pain-points'
        },
        {
          title: '产品价值观',
          id: 'sense-of-worth'
        },
        {
          title: '解决方案',
          id: 'solution'
        }
      ],
      painPointsList: [
        // {
        //   icon: require('@/assets/mobile/icon/pain-points1.png'),
        //   title: '纸质单据不易查询和保存',
        //   describe: '使用纸质单据方式进行线下审批后期查询困难，容易遗失',
        // },
        // {
        //   icon: require('@/assets/mobile/icon/pain-points2.png'),
        //   title: '流程复杂，效率低',
        //   describe: '多级审批导致线下审批过程漫长，领导出差导致单据积压引响考勤和薪酬的核算效率',
        // },
        // {
        //   icon: require('@/assets/mobile/icon/pain-points3.png'),
        //   title: '提交人无法实时查看单据状态',
        //   describe: '提单人无法查看单据审批状态无法及时根据情况修正单据，导致其他工作延后',
        // },
        // {
        //   icon: require('@/assets/mobile/icon/pain-points4.png'),
        //   title: '不能与企业制度联动',
        //   describe: '相关单据提交后需要HR核对制度后才知道是否符合企业制度，导致单据的反复提交提升了管理时间成本',
        // },
      ],
      senseOfWorthList: [
        // {
        //   backImg: require('@/assets/mobile/sense-worth-back1.png'),
        //   title: '自助查询',
        //   text: '提供员工自助平台，实现个人信息的在线查询，提升员工的体验感和归属感',
        // },
        // {
        //   backImg: require('@/assets/mobile/sense-worth-back2.png'),
        //   title: '自助提醒',
        //   text: '相关提醒直接推送给员工，减少中间管理环节，提升效率',
        // },
        // {
        //   backImg: require('@/assets/mobile/sense-worth-back3.png'),
        //   title: '自助提单',
        //   text: '根据系统推送的信息，员工能及时进行审批单据的提交（资料变更、证件更迭、考勤单据等等）',
        // },
        // {
        //   backImg: require('@/assets/mobile/sense-worth-back4.png'),
        //   title: '自助审批',
        //   text: '管理人员可以通过移动端进行在线审批和绩效评价，完全实现移动办公的效果',
        // },
      ],
      solutionIndex: 0,
      SolutionList: [
        // {
        //   title: '在线审批，不限用户数，全员参与',
        //   text: '传统的OA系统由于端口限制导致无法全员使用，华跃HR平台具有不限用户数和并发数的优势，可以让企业全员参与单据提交和审批',
        //   img: require('@/assets/mobile/solution1.png'),
        // },
        // {
        //   title: '在线评价，对人才进行综合评价分析',
        //   text: '启用人才在线面试评价，减少了资料录入和沟通环节，更好的帮助企业对人才进行综合评价分析',
        //   img: require('@/assets/mobile/solution2.png'),
        // },
        // {
        //   title: '在线预约，实现快速验证身份',
        //   text: '针对传统访客登记的弊端，华跃移动平台实现提前在线预约审核，与安防门禁等系统联动，即实现了快速验证身份又保证了人员进出安全管控。',
        //   img: require('@/assets/mobile/solution3.png'),
        // },
      ]
    }
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            var elementTop =
              this.$refs[`${this.navList[i].id}`].offsetTop - this.scrollTop - 1
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id
            }
          }
        }
      }, 20)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.$nextTick(() => {
      const nav = this.$refs.nav
      this.offsetTop = nav.offsetTop
    })
    this.getPageColumn()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70
      var scroll = this.scrollTop - this.position
      this.position = this.scrollTop
      if (this.scrollTop <= 400) {
        this.navHeight = 52
        this.navWidth = 80
        this.$refs.nav.style.position = 'relative'
        this.$refs.nav.style.top = '0px'
        this.topNaviId = null
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll
        this.navWidth += 0.12 * scroll
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px'
        this.$refs.nav.style.position = 'relative'
        this.$refs.nav.style.top = '0px'
        this.topNaviId = null
      } else if (headerFixed) {
        this.navHeight = 60
        this.navWidth = 100
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px'
        this.$refs.nav.style.position = 'fixed'
        this.$refs.nav.style.top = offsetHeight / 2 + 70 + 'px'
      }
    },
    goAnchor(i) {
      // var id = '#' + i.id;
      // document.querySelector(id).scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth'
      })
    },

    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1607261116927533056' }
      getColumnChild(params).then(async res => {
        const { result } = res
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '企业痛点') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99 }
            getContentList(data).then(async rrs => {
              const rrsult = rrs.result
              for (var j = 0; j < rrsult.data.length; j++) {
                const rts = await getContentDetail(rrsult.data[j].id)
                const rtsult = rts.result
                var painPointsItem = {
                  title: rtsult.title,
                  icon: rtsult.icon,
                  describe: rtsult.description
                }
                this.painPointsList.push(painPointsItem)
              }
            })
          } else if (result[i].name === '产品价值观') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99 }
            this.valueCenterImg = result[i].icon
            getContentList(data).then(async rrs => {
              const rrsult = rrs.result
              for (var j = 0; j < rrsult.data.length; j++) {
                var senseOfWorthItem = {
                  title: rrsult.data[j].title,
                  backImg: rrsult.data[j].icon,
                  text: rrsult.data[j].description
                }
                // const rts = await getContentDetail(rrsult.data[j].id);
                // const rtsult = rts.result;
                // for (var x = 0; x < rtsult.elements.length; x++) {
                //   valueAnalysisItem.textList.push(rtsult.elements[x].content);
                // }
                this.senseOfWorthList.push(senseOfWorthItem)
              }
            })
          } else if (result[i].name === '解决方案') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99 }
            getContentList(data).then(async rrs => {
              const rrsult = rrs.result
              for (var j = 0; j < rrsult.data.length; j++) {
                var solutionItem = {
                  title: rrsult.data[j].title,
                  text: rrsult.data[j].description,
                  img: rrsult.data[j].icon
                }
                // const rts = await getContentDetail(rrsult.data[j].id);
                // const rtsult = rts.result;
                // for (var x = 0; x < rtsult.elements.length; x++) {
                //   solutionItem.contentList.push(rtsult.elements[x].content);
                // }
                this.SolutionList.push(solutionItem)
              }
            })
          } else if (result[i].name === '顶部图') {
            getColumnDetail(result[i].id).then(rrs => {
              const rrsult = rrs.result
              var content = rrsult.elements.find(obj => obj.name === 'content')
                .content
              var contentdoc = new DOMParser().parseFromString(
                content,
                'text/html'
              )
              this.top.title = rrsult.elements.find(
                obj => obj.name === 'subtitle'
              ).content
              this.top.content = contentdoc.documentElement.textContent.replace(
                /&nbsp;/g,
                ' '
              )
              // this.top = {
              //   imgBack: rrsult.icon,
              // };
            })
          }
        }
      })
    },

    onClick(i) {
      this.solutionIndex = i
    },
    openBealter() {
      this.$refs.altProduct.tobealter()
    },
    openBealter2() {
      this.$refs.ast.drawer  = true
    }
  }
}
</script>

<style lang="less" scoped>
.mobile-terminal {
  background-color: #fff;
  .page-content {
    width: 100%;
    .page-canvas {
      width: 100%;
      height: fit-content;
      min-width: var(--minwidth);
      position: relative;
      background-size: cover;
      overflow: hidden;
      .page-background {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
        }
      }
      .por-container {
        width: 70%;
        max-width: 1200px;
        margin: 0 auto;
        position: relative;
        .solution-info {
          width: 480px;
          height: 560px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          box-sizing: border-box;
          .solution-info-title {
            font-size: 46px;
            font-weight: bold;
            line-height: 55px;
            color: #181818;
            margin-bottom: 29px;
          }
          .solution-info-content {
            font-size: 20px;
            line-height: 32px;
            color: #7b7b7b;
            margin-bottom: 44px;
          }
          // .solution-btn {
          //   width: 142px;
          //   height: 48px;
          //   background-color: #1589fd;
          //   color: #fff;
          //   text-align: center;
          //   line-height: 48px;
          //   cursor: pointer;
          //   border-radius: 24px;
          // }
        }
      }
    }
    .page-nav {
      width: 100%;
      display: flex;
      position: relative;
      justify-content: center;
      z-index: 50;
      .page-tabs {
        margin: 0 auto;
        box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
        border-radius: 2px;
        background-color: #fff;
        display: flex;
        position: absolute;
        top: -26px;
        .page-nav-item {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #181818;
          font-size: 14px;
          cursor: pointer;
        }
        .page-nav-item:hover {
          color: #00b0dc;
        }
        .top-nav-item {
          color: #fff;
          background-color: #00b0dc;
        }
        .top-nav-item:hover {
          color: #fff;
        }
      }
    }
    .pain-points {
      width: 100%;
      padding-top: 115px;
      padding-bottom: 39px;
      background-color: #fafafa;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title {
        font-family: OPPOSans-M;
        font-size: 32px;
        color: #21252b;
        line-height: 1;
        margin-bottom: 70px;
      }
      .pain-points-list {
        width: 1200px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .pain-points-list-item {
          width: 585px;
          height: 187px;
          margin-right: 30px;
          margin-bottom: 30px;
          border-radius: 8px;
          transition: all 0.3s ease-in-out;
          padding: 45px 50px 0 30px;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          .list-item-icon {
            width: 70px;
            height: 70px;
            background-color: #fafafa;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 30px;
            .icon {
              display: block;
            }
          }
          .list-item-text {
            flex: 1;
            margin-top: 10px;
            .list-item-title {
              font-size: 20px;
              font-family: OPPOSans-M;
              color: #21252b;
              line-height: 1;
              margin-bottom: 15px;
            }
            .list-item-describe {
              font-size: 16px;
              font-family: OPPOSans-R;
              color: #5c6066;
              line-height: 24px;
            }
          }
          &:nth-child(2n) {
            margin-right: 0;
          }
          &:hover {
            background: #fff;
            box-shadow: 0px 3px 24px 0px rgba(139, 139, 139, 0.1);
            .list-item-icon {
              background-color: #f7f9fa;
            }
          }
        }
      }
    }
    .sense-of-worth {
      width: 1200px;
      padding-top: 90px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      .title {
        font-size: 32px;
        font-family: OPPOSans-M;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .sense-of-worth-list {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        .sense-worth-item {
          margin-right: 24px;
          width: 282px;
          height: 450px;
          background-color: #fff;
          box-shadow: 0px 3px 24px 0px rgba(139, 139, 139, 0.1);
          border-radius: 10px;
          overflow: hidden;
          padding: 0 40px;
          box-sizing: border-box;
          border: 1px solid #eee;
          .item-content {
            width: 100%;
            margin-top: 250px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            .item-title {
              font-size: 26px;
              font-family: OPPOSans-M;
              color: #21252b;
              line-height: 1;
              margin-bottom: 25px;
            }
            .item-text {
              font-family: OPPOSans-R;
              font-size: 14px;
              color: #5c6066;
              text-align: center;
              line-height: 28px;
            }
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
    .solution {
      width: 1200px;
      margin: 0 auto;
      padding-top: 90px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      .title {
        font-size: 32px;
        font-family: OPPOSans-M;
        color: #21252b;
        line-height: 1;
        margin-bottom: 70px;
      }
      .solution-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .solution-content-tabinfo-wrap {
          width: 310px;
          position: relative;
          .tabinfo-item {
            width: 100%;
            height: 25px;
            padding-left: 17px;
            border-left: 2px solid transparent;
            box-sizing: border-box;
            line-height: 25px;
            font-family: OPPOSans-R;
            font-size: 18px;
            color: #5c6066;
            position: relative;
            z-index: 1;
            cursor: pointer;
            margin-bottom: 40px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .chack-tabInfo {
            border-left-color: #00b0dc;
            color: #00b0dc;
          }
          &::after {
            z-index: 0;
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 2px;
            height: 100%;
            background-color: #ebe8e8;
          }
        }
        .solution-content___tabText {
          width: 740px;
          height: 636px;
          .solution-content__tabWrap {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            .content__tabWrap-top {
              width: 100%;
              .solution-content__tabtit {
                font-family: OPPOSans-M;
                font-size: 30px;
                color: #21252b;
                line-height: 1;
                margin-bottom: 30px;
                margin-left: 16px;
              }
              .solution-content__tabDes {
                font-family: OPPOSans-R;
                font-size: 16px;
                color: #5c6066;
                line-height: 26px;
                margin-left: 16px;
              }
            }
            .solution-content__tabImage {
              width: 100%;
              height: auto;
              display: block;
            }
          }
          .tabContentWrap-enter-active {
            animation: bounce-in 0.5s;
          }
          .tabContentWrap-leave-active {
            animation: bounce-in 0s reverse;
          }
          @keyframes bounce-in {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
</style>
